/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

export const ErrorBlock = ({ errors }) => (
  errors && errors.map(error => (
    <div
      className="error"
      key={error.id}
    >
      {error.message}
    </div>))
);

ErrorBlock.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
};
